import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { HeroImageTextStory } from "../shared/hero-image";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import styles from "./styles.m.css";
import { VikatanResponsiveContainer, PGAdwithAd, VikatanStickyTop } from "../../../../rows/ad-free";
import StoryMidPromotion from "../../storyMidContent";
import { isPremium } from "../../../../../data/story";
import { humanizeDate } from "../../../../utils/time-format";
import { DeepBI, GA } from "../../../../../integrations";

import Media from "react-media";

import Icon from "../../../../atoms/icon";
import { fetchvuuklegetCommentCount } from "../../../../../api";
import { ScrollPercentage } from "react-scroll-percentage";
// import AudioEmbedWidget from "../../audio-emebed-widget";
import MyVikatanHeader from "../../../../rows/myvikatan-header";
import AISummaryWidget from "../../../../atoms/ai-summary";
import GooglePreference from "../../../../atoms/google-preference";

function TextStory(props, data) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderarticleFooter = get(props, ["renderarticleFooter"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);

  const section = get(props, ["story", "sections", "0"], null);
  const storyHeadline = get(props, ["story", "subheadline"], () => null);
  const singleCard = get(props, ["story", "cards"], null);
  const storyIndex = get(props, ["index"], 0);
  const glance = get(props, ["glance"]);
  const GetStoryScrollPercentage = get(props, ["GetStoryScrollPercentage"], () => null);
  const story = get(props, ["story"], () => null);
  const storyId = get(props, ["story", "id"], "");
  const [readMore, setReadMore] = useState(false);
  const cards = readMore ? (isPremium(story) ? [] : singleCard.slice(0, 1)) : singleCard;
  const summaryText = get(story, ["metadata", "summary"], null);
  const [userType, setUserType] = useState("F");
  const expandComments = get(props, ["expandComments"], () => null);
  const ElementBasedAd = get(props, ["config", "ElementBasedAd"], false);
  // const [iframeVisible, setIframeVisible] = useState(true);

  const cardLength = cards.length;

  const [commentsCount, setCommentsCount] = useState(null);

  // const [showIplArticleBanner, setShowIplArticleBanner] = useState(false);
  const [Percentage, setPercentage] = useState(0);

  // useEffect(() => {
  //   const checkDomain = () => {
  //     const allowedDomain = "sports.vikatan.com";
  //     const hostname = global.location.hostname || "";
  //     setShowIplArticleBanner(hostname === allowedDomain);
  //   };

  //   checkDomain();
  // }, []);

  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      if (user) {
        setUserType(user.userType);

        if (isPremium(story)) {
          setReadMore(false); // Premium content, collapse or hide
        } else if (user.userType === "P" || user.userType === "T" || user.userType === "R") {
          setReadMore(false); // User types P, T, R, collapse or hide
        } else {
          setReadMore(false); // Otherwise, show more content
        }
      }
    });
  }, []);

  useEffect(
    () => {
      global.userPromise.catch(() => ({})).then(user => {
        if (user) {
          if (user.userType === "P" || user.userType === "T" || user.userType === "R") {
            GetStoryScrollPercentage(Percentage);
          } else {
            if (!readMore) {
              GetStoryScrollPercentage(Percentage);
            } else {
              if (Percentage >= 25) {
                GetStoryScrollPercentage(25);
              }
            }
          }
        }
      });
    },
    [Percentage]
  );

  useEffect(() => {
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        setCommentsCount(res.data);
      })
      .catch(error => {
        console.error("Error fetching comments count:", error);
      });
  }, []);

  const adShow = isPremium(story) ? !readMore : true;

  const [showShare, setShowShare] = useState(false);

  // const [expanded, setExpanded] = useState(false);

  const handleShareClick = () => {
    setShowShare(!showShare);
  };

  const scrollToComments = () => {
    expandComments();
    const commentsWidgetContainer = document.getElementById("commentsWidgetContainer");
    if (commentsWidgetContainer) {
      commentsWidgetContainer.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleChange = () => {
    const Sendstory = get(props, ["story"], () => null);
    DeepBI.PingReadmore(Sendstory);
    GA.customEvent("articlereadmore", " clicked", storyHeadline);
    setReadMore(false);
  };

  const heroimageWithShare = (
    <React.Fragment>
      <HeroImageTextStory story={props.story} subSection={section} config={props.config} />
    </React.Fragment>
  );

  const cluster = get(story, ["metadata", "story-attributes", "cluster", "0"], "");

  // useEffect(() => {
  //   window.addEventListener("message", function(message) {
  //     if (message.data.type === "expand") {
  //       console.log("Received expand message");
  //       setExpanded(true); // Set expanded state based on event data
  //     }
  //     if (message.data.type === "collapse") {
  //       console.log("Received collapse message");
  //       setExpanded(false); // Set expanded state to false when the collapse message is received
  //     }
  //   });
  //   return () => {
  //     window.removeEventListener("message", function(message) {
  //       // Optionally remove the event listener when the component unmounts
  //     });
  //   };
  // }, []);

  // const iplArticleBanner = showIplArticleBanner ? (
  //   <div className={styles["ipl-article-banner"]}>
  //     <div className="hidden-mobile">
  //       <a
  //         href="https://sports.vikatan.com/cricket/icc-t20-world-cup?utm_source=story_banner"
  //         rel="noopener noreferrer"
  //         target="_blank"
  //       >
  //         <img
  //           src="https://media.vikatan.com/vikatan/2026-02-23/ksw74z4b/VikatanSathyaManst20worldcuparticletopbanner700x120.png?format=webp&w=700&q=90"
  //           alt=""
  //         />
  //       </a>
  //     </div>
  //     <div className="hidden-desktop">
  //       <a
  //         href="https://sports.vikatan.com/cricket/icc-t20-world-cup?utm_source=story_banner"
  //         rel="noopener noreferrer"
  //         target="_blank"
  //       >
  //         <img
  //           src="https://media.vikatan.com/vikatan/2026-02-23/e0uxu8b7/VikatanSathyaManst20worldcuparticlemobiletopbanner375x120.png?format=webp&w=300&q=90"
  //           alt=""
  //         />
  //       </a>
  //     </div>
  //   </div>
  // ) : null;

  // const handleCloseIframe = () => {
  //   const pingStory = get(props, ["story"], () => null);
  //   setIframeVisible(false);
  //   DeepBI.PingAudioWebplayer(pingStory);
  // };

  // const [isAllowedHost, setIsAllowedHost] = useState(false);

  // useEffect(() => {
  //   if (typeof global !== "undefined") {
  //     const hostname = global.location.hostname;
  //     setIsAllowedHost(hostname !== "sports.vikatan.com");
  //   }
  // }, []);

  return (
    <div className="page-content">
      {cluster === "MyVikatan" ? (
        <div>
          <MyVikatanHeader showMenu={true} showBanner={false} />
        </div>
      ) : (
        ""
      )}
      <div className={`container ${styles["story-grid"]}`}>
        <div className={styles["main-content"]}>
          <article className={`${styles["story-body"]} js-story`}>
            {/* {cluster === "MyVikatan" && isAllowedHost ? (
              <div className={styles["manoravels-banner"]}>
                <div className="hidden-mobile">
                  <a href="https://www.manohartravels.com/" rel="noopener noreferrer" target="_blank">
                    <img
                      src="https://media.vikatan.com/vikatan/2025-05-29/o659eviz/manotravels-desktop-banner.jpeg?format=webp&w=700&q=90"
                      className={styles["mbanner"]}
                    />
                  </a>
                </div>
                <div className="hidden-desktop">
                  <a href="https://www.manohartravels.com/" rel="noopener noreferrer" target="_blank">
                    <img
                      src="https://media.vikatan.com/vikatan/2025-05-29/qh4pxg6z/manotravels-mobile-300.jpg?format=webp&w=300&q=90"
                      className={styles["mbanner"]}
                    />
                  </a>
                </div>
              </div>
            ) : (
              ""
            )} */}
            {/* {iplArticleBanner} */}
            <VikatanStickyTop />
            <Breadcrumb subSection={section} config={props.config} />
            <ScrollPercentage>
              {({ percentage, ref }) => {
                const percentageRound = percentage.toFixed(2) * 100;
                if (percentageRound) {
                  setPercentage(percentageRound);
                }
                return (
                  <div ref={ref}>
                    <div>
                      {renderHeaderCard("", true, false)}
                      <p className={`subheadline-main ${styles["subheadline"]}`}>{storyHeadline}</p>
                      <div className={styles["published-time-wrap"]}>
                        {story["first-published-at"] && (
                          <span className={styles["published"]}>
                            Published:
                            <time
                              className={styles.time}
                              dateTime={new Date(story["first-published-at"]).toISOString()}
                            >
                              {humanizeDate(story["first-published-at"], "relative")}
                            </time>
                          </span>
                        )}
                        {story["last-published-at"] && (
                          <span className={styles["updated"]}>
                            Updated:
                            <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                              {humanizeDate(story["last-published-at"], "relative")}
                            </time>
                          </span>
                        )}
                      </div>
                      <div className="vikatan-top-ad-width ad">
                        <div className="ad-container vikatan-top-ad">
                          <Media query="(max-width:768px)">
                            {matches =>
                              matches ? (
                                <div
                                  className={`mobile ${
                                    userType === "P" || userType === "T" || userType === "R" ? "" : "ad_300_250"
                                  }`}
                                >
                                  <PGAdwithAd
                                    adId={`Vikatan2023_Mobile_AP_ATF_336x280`}
                                    adSize={[[336, 280], [300, 250]]}
                                    minHeight={280}
                                    adDivId="div-ad-desk-3849069-1690281338-0"
                                    class="ad_300_250"
                                    story={story}
                                    config={props.config}
                                  />
                                </div>
                              ) : null
                            }
                          </Media>
                        </div>
                      </div>
                      <div className={styles["hero-image-wrapper"]}>{heroimageWithShare}</div>
                    </div>
                    <div className={styles["audio-share-wrapper"]}>
                      <div className={styles["audio-comments-share"]}>
                        <div>
                          {summaryText ? (
                            <AISummaryWidget story={story} renderSocialMedia={renderSocialMedia} />
                          ) : (
                            <GooglePreference story={story} />
                          )}
                        </div>
                        <div className={styles["box-div"]} onClick={scrollToComments}>
                          <Icon type="comment" />
                          <span className={styles["channel-txt"]}>
                            {commentsCount !== null ? commentsCount[storyId] || 0 : 0}
                          </span>
                          <span className={`${styles["channel-txt"]} hidden-mobile`}>Comments</span>
                        </div>
                        <div
                          className={`${styles["box-div"]} ${showShare ? styles["share-active"] : ""} `}
                          onClick={handleShareClick}
                        >
                          <Icon type="socialshare" />
                          <span className={`${styles["channel-txt"]} hidden-mobile`}>Share</span>
                        </div>
                      </div>

                      <div className={styles["social-share-wrapper"]}>
                        {showShare && !readMore && renderSocialMedia("", false)}
                      </div>
                    </div>

                    <div className="mobile hidden-desktop" />
                    <div>
                      {cards &&
                        cards.map((card, index) => {
                          return (
                            <React.Fragment key={card.id}>
                              {index === 1 ? <StoryMidPromotion story={props.story} /> : null}
                              <StoryCard
                                card={card}
                                story={props.story}
                                showCard={readMore}
                                index={index}
                                storyIndex={storyIndex}
                                cardLength={cardLength}
                                glance={glance}
                                config={props.config}
                              />
                              {!readMore &&
                                ElementBasedAd === false && (
                                  <VikatanResponsiveContainer
                                    placement="text-story"
                                    adtype={parseInt(index + 1)}
                                    storyId={storyId}
                                    className="ad_300_250"
                                    story={story}
                                    config={props.config}
                                  />
                                )}
                            </React.Fragment>
                          );
                        })}
                    </div>
                  </div>
                );
              }}
            </ScrollPercentage>
            {readMore && (
              <div className={styles["readmore-wrapp"]}>
                <div onClick={() => handleChange()} className={styles["read-more-button"]}>
                  <span>மேலும் படிக்க</span>
                  <div className={styles["arrows"]}>
                    <Icon type={"angle-right"} />
                    <Icon type={"angle-right"} />
                  </div>
                </div>
              </div>
            )}

            <div id="commentsWidgetContainer">{renderarticleFooter(readMore)}</div>
          </article>
          {renderFooter(readMore)}
        </div>
        {renderSidebar(adShow)}
      </div>
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any,
  metadata: PropTypes.shape({
    "reference-url": PropTypes.string
  })
});
TextStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  isAccessible: PropTypes.bool,
  relatedStories: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      story: story
    })
  ),
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func,
  handleExpandStory: PropTypes.func,
  renderTextStoryHeaderCard: PropTypes.func
};

export { TextStory };
